var $6226bc1c3f7224eb$exports = {};
$6226bc1c3f7224eb$exports = {
    "valid": `V\xe1lido`
};


export {$6226bc1c3f7224eb$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
